const SOCIAL_MEDIA = {
    linkedin: 'https://br.linkedin.com/company/whizr',
    facebook: 'https://www.facebook.com/profile.php?id=100068044070988',
    instagram: 'https://instagram.com/whizr',
}

export default SOCIAL_MEDIA;